import Cookies from "js-cookie";

const refreshToken = Cookies.get('refresToken');
const userToken = Cookies.get('jwt');
const userId = Cookies.get('userId');
const username = Cookies.get('username');
const userRole = Cookies.get('roleId');

export { refreshToken, userToken, userId, username, userRole };